import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Loader2 } from "lucide-react";

export default function ProtectedRoute({ children, adminOnly = false, roles = null }) {
  const { user, loading } = useAuth();

  if (loading || user === null) {
    return (
      <div className="flex h-screen items-center justify-center bg-brand-bg">
        <Loader2 className="h-8 w-8 animate-spin text-brand-gold" />
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  const role = user.role;
  if (adminOnly && role !== "admin" && role !== "super_admin") return <Navigate to="/" replace />;
  if (roles && !roles.includes(role)) return <Navigate to="/" replace />;
  return children;
}
